import { AppBar, type AppBarProps, Box, IconButton, Toolbar } from '@mui/material';
import { listClusters } from '@qdrant/qdrant-cloud-public-api/cluster/v1/connect-query';
import { MenuIcon } from 'lucide-react';
import { memo } from 'react';
import { IconButtonLink } from '@/router/Link';
import { useSafeAccountId } from '@/routes/_authenticated/_dashboard/accounts/$accountId/route.hooks';
import { mergeSx } from '@/utils/mergeSx';
import { WithRpcPermissions } from '../AccessManagement/WithRpcPermissions/WithRpcPermissions';
import { IncidentBanner } from '../Common/IncidentBanner';
import { LogoIcon } from '../Logo';

export const DASHBOARD_SIDEBAR_WIDTH = '280px';

export const DashboardAppBarInner = ({ children, sx, ...props }: AppBarProps) => (
  <AppBar
    sx={mergeSx(
      {
        background: 'background.default',
        justifyContent: 'center',
        pl: {
          lg: DASHBOARD_SIDEBAR_WIDTH,
        },
      },
      sx,
    )}
    {...props}
  >
    <Toolbar sx={{ gap: 1, alignItems: 'center' }}>{children}</Toolbar>
  </AppBar>
);

export const DashboardAppBar = memo(function DashboardAppBar({ onMenuClick }: { onMenuClick: () => void }) {
  const accountId = useSafeAccountId();

  return (
    <DashboardAppBarInner>
      <Box sx={{ display: { lg: 'none' } }}>
        {accountId ? (
          <WithRpcPermissions
            methods={[listClusters]}
            show="always"
            render={({ matches }) => (
              <IconButtonLink to={matches ? '/accounts/$accountId/clusters' : '/get-started'} params={{ accountId }}>
                <LogoIcon size={20} />
              </IconButtonLink>
            )}
          />
        ) : (
          <IconButtonLink to="/preferences">
            <LogoIcon size={20} />
          </IconButtonLink>
        )}
        <IconButton onClick={onMenuClick}>
          <MenuIcon size={20} />
        </IconButton>
      </Box>
      <IncidentBanner />
    </DashboardAppBarInner>
  );
});
